package team.platforma.aicombo.activity.auth.component

import team.platforma.aicombo.activity.auth.component.fragment.AuthFragment
import team.platforma.aicombo.activity.auth.component.fragment.password_restore.EnterRestoreCodeFragment
import team.platforma.aicombo.activity.auth.component.fragment.password_restore.EnterRestoreMailFragment
import team.platforma.aicombo.activity.auth.component.fragment.password_restore.RestorePasswordFragment
import team.platforma.aicombo.activity.auth.component.fragment.registration.CreatePasswordFragment
import team.platforma.aicombo.activity.auth.component.fragment.registration.EnterEmailFragment
import team.platforma.aicombo.activity.auth.component.fragment.registration.EnterVerificationCodeFragment
import team.platforma.extra_nav.component.component_of_activity.Component

object AuthComponent : Component(
    route = "auth_component",
    fragments = listOf(
        AuthFragment,
        EnterRestoreMailFragment,
        RestorePasswordFragment,
        EnterVerificationCodeFragment,
        CreatePasswordFragment,
        EnterEmailFragment,
        EnterRestoreCodeFragment
    )
)